<!--  -->
<template>
     <div class='wrapper box_v'>
        <div class="title">年龄统计</div>
        <!-- <div class='box_f1' id="echart_cheif_age" style="width:460px;height:200px"></div> -->
		<div class="itemwrapper box">
			<div v-for="(item,index) in list" :key="`cheifage_${index}`" class="item box box_f1 box box_v">
				<div class="itemTitle">{{item.label}}</div>
				<div class="cylinder" :style="'marginBottom:'+(item.stylePercent*2/3)+'px'">
					
					<div class="ellipse"></div>
					<div class="rectangle" :style="'height:'+(2*item.stylePercent+30)+'px'"></div>
				</div>
				<div class="itemLabel">{{item.age}}</div>
			</div>
		</div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
			list:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		getData(){
			this.$get(this.urlobj.monitor_eventUserAge).then(res=>{
				let allPeople = 0
				let maxAge = 0
				res.rows.forEach(item=>{
					if(maxAge<item.count) maxAge = item.count
					allPeople += item.count
				})
				console.log(allPeople)
				this.list = res.rows.map(item=>{
					return {
						...item,
						stylePercent:((item.count/maxAge)*100).toFixed(2),
						percent:((item.count/allPeople)*100).toFixed(2),
						label:((item.count/allPeople)*100).toFixed(2)+'%\n'+item.count+'人'
					}
				})
			})
		}
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //this.initEcharts()
        //this.initHighChart()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    //height:100%;
    margin-top:10px;
    width:100%;
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
.colorName{
	color:black;
}
.item{
	justify-content: flex-end
}
.cylinder {
    position: relative;
	transform: rotateX(70deg);
	margin:0 auto
}
 
.ellipse {
    width: 30px;
    height: 30px; 
    background: #00A0E9;
    border-radius: 15px;
}
 
.rectangle {
    width: 30px;
    height: 200px;
    position: absolute;
    background: linear-gradient(90deg, #0084FF 0%, rgba(0, 127, 246, 0.2) 63%, #017CF1 100%);
    top: 0;
    left: 0; 
    border-radius: 15px;
    z-index: -1;
}

.itemTitle{
	font-size: 14px;
	color: #27BBFF;
	text-align: center;
	white-space: pre-wrap;
}
.itemLabel{
	font-size: 14px;
	color: #fff;
	text-align: center
}
.itemwrapper{
	padding:10px 30px;
	height:100%;
}
</style>